export default class CustomerDocumentSuccessfullyUpdatedViewModel {
  get columbus_login_page() {
    return process.env.VUE_APP_COLUMBUS_WEB_LOGIN_URL;
  }
}
